module.exports = "https://99designs-start-assets.imgix.net/js/c9ab19e38a7c91534898b07ae4c54718.png";